import React, { useState } from 'react';
import { Stack } from '@bay-email/editor';
import { Button, Collapse } from '@arco-design/web-react';
import { HtmlEditor } from '../../UI/HtmlEditor';
import { CollapseWrapper } from '../../attributes/CollapseWrapper';
import { Padding } from '../../attributes/Padding';
import { BackgroundColor } from '../../attributes/BackgroundColor';
import { ClassName } from '../../attributes/ClassName';
import { t } from '@bay-email/core';
import { BsCodeSlash } from 'react-icons/bs';

export function Raw() {
	const [visible, setVisible] = useState(false);

	return (
		<CollapseWrapper
			isChevron
			iconPosition='right'
			defaultActiveKey={['0', '1', '2']}
			style={{ padding: 0 }}
		>
			<Collapse.Item
				name='0'
				header={t('HTML Content')}
				contentStyle={{ padding: 0 }}
			>
				<div className='p-3'>
					<Stack
						vertical
						spacing='tight'
					>
						<Button
							type='primary'
							size='large'
							onClick={() => setVisible(true)}
							icon={<BsCodeSlash style={{ fontSize: 18 }} />}
							long
						>
							{t('Edit HTML')}
						</Button>
					</Stack>
				</div>
			</Collapse.Item>
			<Collapse.Item
				name='1'
				header={t('Dimension')}
				contentStyle={{ padding: 0 }}
			>
				<div className='p-3 pt-4'>
					<Padding />
				</div>
			</Collapse.Item>
			<Collapse.Item
				name='2'
				header={t('Styling')}
				contentStyle={{ padding: 0 }}
			>
				<div className='p-3 pt-4'>
					<BackgroundColor supportsDynamic={false} />
				</div>
			</Collapse.Item>
			<Collapse.Item
				name='3'
				header={t('Extra')}
				contentStyle={{ padding: 0 }}
			>
				<div className='p-3'>
					<ClassName />
				</div>
			</Collapse.Item>
			<HtmlEditor
				visible={visible}
				setVisible={setVisible}
			/>
		</CollapseWrapper>
	);
}
